import React from 'react';

import SessionLayout from '../layouts/Session/Session';

import Timeout from '../components/Session/Timeout';
import {setPageTitle} from '../utils/helpers';

const TimeoutPageContainer = () => {
  setPageTitle('Log out | Investec Save');

  return (
    <SessionLayout>
      <Timeout />
    </SessionLayout>
  );

};

export default TimeoutPageContainer;
